import StepId from "@/model/progress/StepId"

const providerKey = "synchrony_standard*"

export default {
    providerKey,

    routes: [
        {
            name: "synchronyPrequalifyOfferReviewNext",
            path: `/providers/${providerKey}/modes/prequalify/offerReviewNext`,
            meta: { step: StepId.ACCEPT_OFFER },
            redirect: `/providers/${providerKey}/checkCalifornia`,
        },
        {
            name: "synchronyPaymentPlanReview",
            path: `/providers/${providerKey}/paymentPlanReview`,
            meta: { step: StepId.ACCEPT_OFFER },
            extends: "paymentPlanReview",
            component: () => import("@/views/provider/synchrony/SynchronyPlanReviewView.vue"),
        },
        {
            name: "synchronyLoanPaymentPlanReview",
            path: `/providers/${providerKey}/paymentPlanLoanReview`,
            meta: { step: StepId.ACCEPT_OFFER },
            extends: "paymentPlanReview",
            component: () => import("@/views/provider/synchrony/SynchronyLoanPlanReviewView.vue"),
        },
        {
            name: "synchronyTerms",
            extends: "terms",
            path: `/providers/${providerKey}/terms`,
            component: () => import("@/views/provider/synchrony/SynchronyTermsView.vue"),
        },
        {
            name: "existingAccount",
            path: `/providers/${providerKey}/existingAccount`,
            meta: { step: StepId.PAYMENT_OPTIONS },
            component: () => import("@/views/provider/synchrony/SynchronyExistingAccountView.vue"),
        },
        {
            name: "PayMonthlyIframe",
            path: `/providers/${providerKey}/payMonthlyIframe`,
            meta: { step: StepId.COMPLETE },
            component: () => import(`@/views/provider/synchrony/PayMonthlyIframeView.vue`),
        },
        {
            name: "finishWithExistingAccount",
            path: `/providers/${providerKey}/finishWithExistingAccount`,
            meta: { step: StepId.COMPLETE },
            component: () => import("@/views/provider/synchrony/SynchronyFinishWithExistingAccountView.vue"),
        },
        {
            name: "PayMonthlyPending",
            path: `/providers/${providerKey}/payMonthlyPending`,
            meta: { step: StepId.ACCEPT_OFFER },
            component: () => import(`@/views/provider/synchrony/PayMonthlyPendingView.vue`),
        },
        {
            name: "PayMonthlyDeclined",
            path: `/providers/${providerKey}/payMonthlyDeclined`,
            meta: { step: StepId.COMPLETE },
            component: () => import(`@/views/provider/synchrony/PayMonthlyDeclinedView.vue`),
        },
        {
            name: "payMonthlyLoader",
            path: `/providers/${providerKey}/payMonthlyLoader`,
            component: () => import(`@/views/provider/synchrony/PayMonthlyLoaderView.vue`),
            props: route => ({
                refreshPendingStatus: route.query.refreshPendingStatus === "true",
            }),
        },
    ],
}
